import React from 'react';

import { graphql } from 'gatsby';

import { Box, useTheme } from '@mui/material';

import { IndustryHeroScroller } from '../../components/industry-hero-scroller';
import { ComponentProps, PossibleContentSections } from '../fragment-and-types';
import { ClaimTextData } from './claim-text';
import { gatsbyImageDataFromStrapiImage } from './image';
import { ImageSlide } from './image-slide';

export const ParallaxImageFragment = graphql`
  fragment ParallaxImageFragment on STRAPI__COMPONENT_SHARED_PARALLAX_SLIDE {
    strapi_component
    backgroundImage {
      ...ImageSlideFragment
    }
    claimText {
      ...ClaimTextFragment
    }
  }
`;

export const componentName = 'shared.parallax-slide';

export type ParallaxImageData = { strapi_component: typeof componentName } & {
  backgroundImage: ImageSlide;
  claimText: ClaimTextData;
};

export const isParallaxImage = (
  component: PossibleContentSections,
): component is ParallaxImageData => {
  return component.strapi_component === componentName;
};

export const StrapiParallaxImage = ({
  backgroundImage,

  claimText,
}: ComponentProps<ParallaxImageData>) => {
  const theme = useTheme();

  return (
    <>
      <Box sx={{ height: { xs: '70px', sm: '120px', md: '170px' } }} />
      <IndustryHeroScroller
        title={backgroundImage.title || ''}
        subtitle={backgroundImage.subtitle || ''}
        subClaim={claimText.claim}
        introText={claimText.text}
        backgroundImage={gatsbyImageDataFromStrapiImage(backgroundImage, theme)}
      />
    </>
  );
};

export const config = {
  isComponent: isParallaxImage,
  Component: StrapiParallaxImage,
  componentName,
};
